import { Store } from 'src/store/index';

const getFrameUpsellFrameTitle = (store: Store) => store.upsell.frameUpsellPopupData?.items[store.upsell.frameUpsellSelectedFrame || 0]?.name;
export default getFrameUpsellFrameTitle;
